import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "table-content" }

import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { useLogActivityStore } from "@/stores/management/log-activity";
import { formatDateTime } from "@/utils/helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListLogActivity',
  setup(__props) {

const headers: Header[] = [
  { text: "User", value: "user_name" },
  { text: "Module", value: "module" },
  { text: "Action", value: "action" },
  { text: "Description", value: "description" },
  { text: "Date", value: "created_at" },
];

const logActivityStore = useLogActivityStore();
const page = ref<number>(1);
const limit = ref<number>(10);
const totalData = ref<number>(0);
const listLog = ref<any>([]);
const isLoading = ref(false);

const loadDataItems = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await logActivityStore.dispatchGetList(
    page.value,
    limit.value,
    query
  );

  if (success) {
    listLog.value = await logActivityStore.logs.items;
    page.value = await logActivityStore.logs.page;
    limit.value = await logActivityStore.logs.pageSize;
    totalData.value = await logActivityStore.logs.total;
  }
  isLoading.value = false;
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataItems();
};

loadDataItems();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Log Activity User")
      ], -1)),
      _createVNode(FilterTable, { onSearchByQuery: loadDataItems }),
      _createElementVNode("div", _hoisted_3, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(BaseLoading, { key: 0 }))
          : _createCommentVNode("", true),
        (!isLoading.value)
          ? (_openBlock(), _createBlock(_unref(EasyDataTable), {
              key: 1,
              headers: headers,
              items: listLog.value,
              "show-index": "",
              "server-options": {
            page: page.value,
            rowsPerPage: limit.value,
          },
              "server-items-length": totalData.value,
              "onUpdate:serverOptions": handleServerOptionsUpdate,
              "buttons-pagination": ""
            }, {
              "item-created_at": _withCtx((props) => [
                _createTextVNode(_toDisplayString(_unref(formatDateTime)(props.created_at)), 1)
              ]),
              _: 1
            }, 8, ["items", "server-options", "server-items-length"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})